/**
 * SASADM-0164 — per-tenant Microsoft Entra redirect-URI choice (saas-auth SASATH-0379).
 *
 * One SUPER_ADMIN-gated read on saas-auth's tenant-scoped
 * `/api/saas-admin/tenants/{tenantId}/entra-sso/redirect-uri`: the saved choice
 * (`SYSTEM` | `WHITELABEL`), the URI for it, and both candidate URIs. saas-admin
 * computes no URI itself — this read is authoritative. The choice is WRITTEN through
 * the existing integration-settings upsert (`entra-sso` group, non-secret key
 * `redirect_host`), not through this module.
 *
 * ENVELOPE: the response is the standard `ApiResponse<T>` envelope (like every other
 * `api/admin/*` module), so this uses the strict `request<ApiResponse<T>>()` +
 * `unwrap()` pattern — NOT tolerant/dual-shape parsing.
 */
import { request, unwrap } from '../client';
import type { ApiResponse, EntraRedirectUriDto } from '../types';

const base = (tenantId: number) => `/api/saas-admin/tenants/${tenantId}/entra-sso`;

export const entraSsoApi = {
  /** The tenant's Entra redirect-URI choice and both candidate URIs (SUPER_ADMIN-gated). */
  async getRedirectUri(tenantId: number): Promise<EntraRedirectUriDto> {
    const res = await request<ApiResponse<EntraRedirectUriDto>>(
      'GET',
      `${base(tenantId)}/redirect-uri`,
    );
    return unwrap(res);
  },
};
